import styled from 'styled-components'

export const Wrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
  h4 {
    ${props => props.theme.typography.h4}
    text-align: center;
    margin: 0px auto 8px;
  }
  p {
    ${props => props.theme.typography.p2};
    color: ${props => props.theme.color.dimgrey};
    text-align: center;
    margin: 0 auto 16px;
  }
`
